export const TOKEN = '@lex-content/token'
